import { PhotoStudioAIMaskScope, PhotoStudioFileType } from 'constants/visual/photoStudio'
import { UploadType, getSignedURLRetrieverSeq } from 'components/common/FileAPI/fileUtils'

import { Endpoints } from 'dataQueries/photoStudio.query'
import { useFileAPI } from 'components/common/FileAPI'

/**
 * Reusable mask upload hook for AI processing
 * Can be used for all AI Photo Studio tools
 */
export const useReusableMaskUpload = (
  assignmentId: string,
  scope: PhotoStudioAIMaskScope = PhotoStudioAIMaskScope.DEFAULT
) => {
  return useFileAPI(scope, {
    uploadUrlResolver: getSignedURLRetrieverSeq((fileEntry, api) => api.post(
      Endpoints.AI_VISUALS_MASK_UPLOAD_URL,
      { assignmentId: assignmentId.toString() },
      {
        filename: fileEntry.fileObject.name,
        contentType: PhotoStudioFileType.MASK,
      },
      true,
      {
        params: {
          uploadType: UploadType.STANDARD
        }
      }
    ))
  })
}
